<template>
  <el-dialog
    title="Edit Widget"
    visible
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <component
      :is="formComponent"
      ref="form"
      :widget="widget"
      @submitted="submitted"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button
        @click.native="$emit('update:isShow', false)"
      >
        Cancel
      </el-button>
      <el-button
        type="primary"
        @click.native="$refs['form'].submit()"
      >
        Save
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import Chart from '@/plugins/dashboard/classes/Chart'
import ChartEditForm from '@/plugins/dashboard/components/ChartEditForm'
import Widgets from '@/plugins/dashboard/widgets'

export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    widget: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isFullscreen: false
    }
  },
  computed: {
    formComponent () {
      if (Widgets[this.widget[Object.keys(this.widget)[0]]['name']].prototype instanceof Chart) {
        return ChartEditForm
      } else {
        return Widgets[this.widget[Object.keys(this.widget)[0]]['name']].configure
      }
    }
  },
  methods: {
    submitted (widget) {
      this.$emit('submitted', widget)
      this.$emit('update:isShow', false)
    }
  }
}
</script>

<style>

</style>
